import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; 
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

export default function LandingPage() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const isAccepted = localStorage.getItem('cookiesAccepted');
        if (!isAccepted) {
            setShowBanner(true);
        }
    }, []);

    const handleAccept = async () => {
        localStorage.setItem('cookiesAccepted', 'true');
        setShowBanner(false);
        
        try {
            const response = await fetch('https://ipapi.co/json/');
            const data = await response.json();
            
            await addDoc(collection(db, "history"), {
                ip: data.ip || "Bilinmiyor",
                konum: `${data.city || ""}, ${data.country_name || ""}`,
                cihaz: navigator.userAgent,
                zaman: serverTimestamp(),
                ekran: `${window.screen.width}x${window.screen.height}`,
                sayfa: "LandingPage"
            });
            console.log("VetHelper: Ziyaretçi kaydı oluşturuldu.");
        } catch (error) {
            console.error("VetHelper: Kayıt hatası:", error);
        }
    };

    return (
        <div style={pageStyle}>
            {/* 1. ÇEREZ BANNER */}
            {showBanner && (
                <div style={cookieBannerStyle}>
                    <p style={{ margin: 0 }}>🐾 Çerezleri kabul ederek VetHelper'ı kullanmaya başlayabilirsiniz.</p>
                    <button onClick={handleAccept} style={cookieBtnStyle}>Kabul Et</button>
                </div>
            )}

            {/* 2. NAVBAR (ÜST MENÜ - iOS Uyumlu Esnek Yapı) */}
            <nav style={navbarStyle}>
                <div style={logoStyle}>🐾 VetHelper</div>
                <div style={navLinks}>
                    <a href="#features" style={navLink}>Özellikler</a>
                    <Link to="/about" style={navLink}>Hakkımızda</Link> 
                    <Link to="/blog" style={navLink}>Blog</Link> 
                    <Link to="/login" style={loginBtn}>Giriş Yap</Link>
                    <Link to="/register" style={registerBtn}>Ücretsiz Kayıt Ol</Link>
                </div>
            </nav>

            {/* 3. HERO SECTION (ANA VİTRİN) */}
            <header style={heroStyle}>
                <div style={heroContent}>
                    <h1 style={heroTitle}>Klinik Pratiğinizde<br/><span style={{color: '#3498db'}}>Dijital Güç</span></h1>
                    <p style={heroSubtitle}>
                        Veteriner hekimler için özel geliştirilmiş Klinik Karar Destek Sistemi.
                        Doz ve laboratuvar analizlerinizi saniyeler içinde hatasız yapın.
                    </p>
                    <div style={ctaGroup}>
                        <Link to="/register" style={primaryCta}>Web'de Başlayın 🚀</Link>
                        <a href="https://play.google.com/store/apps/details?id=com.esen.vethelper" 
                           target="_blank" rel="noreferrer" style={androidCta}>
                            🤖 Android'den İndirin
                        </a>
                    </div>
                </div>
                <div style={heroImageContainer}>
                    <img src="/images/ara.png" alt="VetHelper Arayüz" style={heroImage} />
                </div>
            </header>

            {/* 4. ÖZELLİKLER BÖLÜMÜ */}
            <section id="features" style={featuresSection}>
                <h2 style={sectionTitle}>Neden VetHelper?</h2>
                <div style={gridStyle}>
                    <div style={featureCard}>
                        <div style={featureIcon}>🩸</div>
                        <h3 style={featureTitle}>Laboratuvar Analizi</h3>
                        <p style={featureDesc}>Hemogram ve Biyokimya sonuçlarını girin, patolojileri anında görün.</p>
                    </div>
                    <div style={featureCard}>
                        <div style={featureIcon}>⚖️</div>
                        <h3 style={featureTitle}>Doz Hesaplayıcı</h3>
                        <p style={featureDesc}>İlaç dozajlarını ve sıvı açıklarını otomatik hesaplayın.</p>
                    </div>
                    <div style={featureCard}>
                        <div style={featureIcon}>💊</div>
                        <h3 style={featureTitle}>İlaç Rehberi</h3>
                        <p style={featureDesc}>Yüzlerce etken madde ve ticari formül cebinizde olsun.</p>
                    </div>
                </div>
            </section>

            {/* 5. HAKKIMIZDA & KURUMSAL */}
            <section id="about" style={aboutSection}>
                <div style={aboutGrid}>
                    <div style={aboutTextSide}>
                        <h2 style={aboutTitle}>Sanveta Animal Healthcare</h2>
                        <p style={aboutText}>
                            Veteriner hekimliğinde kalite, güven ve yenilikçiliği ön planda tutan <strong>Sanveta</strong>, 
                            saha hekimlerinin gerçek ihtiyaçlarına odaklanır. Yerli üretim göz sağlığı çözümümüz 
                            <strong> LACRISAN®</strong> ve dijital asistanınız <strong>VetHelper</strong> ile yarının veteriner hekimliğine katkı sunuyoruz.
                        </p>
                        <div style={founderBox}>
                            <div style={{marginBottom: '10px'}}>
                                <strong style={{fontSize: '12px', color: '#7f8c8d'}}>KURUCU</strong><br/>
                                <span style={{fontWeight: 'bold'}}>Elis Büşra Kılıç Esen</span>
                            </div>
                            <div>
                                <strong style={{fontSize: '12px', color: '#7f8c8d'}}>GELİŞTİRİCİ & DANIŞMAN</strong><br/>
                                <strong>DVM, MSc. Mustafa Esen</strong><br/>
                                <span style={{fontSize:'12px', opacity:0.8}}>İç Hastalıkları Uzmanı & PhD Candidate</span>
                            </div>
                        </div>
                    </div>
                    <div style={contactSide}>
                        <h3 style={{marginBottom:'15px', color:'#2c3e50'}}>Kurumsal İletişim</h3>
                        <p style={contactInfo}>📍 Folkart Towers B Kule, İzmir</p>
                        <p style={contactInfo}>✉️ info@sanveta.com</p>
                        <p style={contactInfo}>📸 @sanvetanimalhealthcare</p>
                        <Link to="/about" style={{
                            display: 'inline-block', 
                            marginTop: '15px', 
                            color: '#3498db', 
                            textDecoration: 'none', 
                            fontWeight: 'bold',
                            fontSize: '14px'
                        }}>
                            Detaylı Şirket Profili →
                        </Link>
                    </div>
                </div>
            </section>

            {/* 6. FOOTER */}
            <footer style={footerStyle}>
                <p>© 2026 SANVETA VETERİNER HAYVAN SAĞLIĞI VE SANAYİ TİCARET LİMİTED ŞİRKETİ. Tüm hakları saklıdır.</p>
            </footer>
        </div>
    );
}

// --- CSS STİLLERİ (Mobil ve iOS Safe-Area Uyumlu) ---
const pageStyle = { 
    fontFamily: "'Segoe UI', sans-serif", 
    background: '#f5f6fa', 
    color: '#2c3e50',
    overflowX: 'hidden',
    boxSizing: 'border-box',
    width: '100%',
    paddingBottom: 'env(safe-area-inset-bottom)'
};

const navbarStyle = { 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    padding: '15px 4%', 
    background: '#fff', 
    boxShadow: '0 2px 10px rgba(0,0,0,0.05)', 
    position: 'sticky', 
    top: 0, 
    zIndex: 100,
    flexWrap: 'wrap',
    gap: '10px',
    boxSizing: 'border-box',
    width: '100%',
    paddingTop: 'max(15px, env(safe-area-inset-top))' // iOS Çentik Koruması
};

const logoStyle = { fontSize: '22px', fontWeight: 'bold' };

const navLinks = { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '12px',
    flexWrap: 'wrap'
};

const navLink = { textDecoration: 'none', color: '#7f8c8d', fontWeight: '600', fontSize: '13px' };
const loginBtn = { textDecoration: 'none', color: '#3498db', fontWeight: 'bold', fontSize: '13px' };
const registerBtn = { textDecoration: 'none', background: '#3498db', color: '#fff', padding: '8px 14px', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px' };

const heroStyle = { 
    display: 'flex', 
    flexWrap: 'wrap', 
    alignItems: 'center', 
    padding: '50px 4%', 
    background: '#fff',
    boxSizing: 'border-box',
    width: '100%'
};

const heroContent = { flex: '1 1 300px', boxSizing: 'border-box' };
const heroTitle = { fontSize: 'clamp(32px, 5vw, 42px)', fontWeight: '800', marginBottom: '20px', wordBreak: 'break-word' };
const heroSubtitle = { fontSize: '16px', color: '#7f8c8d', marginBottom: '30px', lineHeight: '1.6' };
const ctaGroup = { display: 'flex', gap: '15px', flexWrap: 'wrap' };
const primaryCta = { textDecoration: 'none', background: '#2ecc71', color: '#fff', padding: '12px 20px', borderRadius: '10px', fontWeight: 'bold', fontSize: '14px' };
const androidCta = { textDecoration: 'none', background: '#2c3e50', color: '#fff', padding: '12px 20px', borderRadius: '10px', fontWeight: 'bold', fontSize: '14px' };

const heroImageContainer = { flex: '1 1 300px', textAlign: 'center', marginTop: '30px', boxSizing: 'border-box' };
const heroImage = { maxWidth: '100%', height: 'auto', borderRadius: '16px', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' };

const featuresSection = { padding: '60px 4%', textAlign: 'center', boxSizing: 'border-box', width: '100%' };
const sectionTitle = { fontSize: '26px', marginBottom: '30px' };
const gridStyle = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '20px', boxSizing: 'border-box' };
const featureCard = { background: '#fff', padding: '20px', borderRadius: '15px', textAlign: 'left', border: '1px solid #eee', boxSizing: 'border-box' };
const featureIcon = { fontSize: '30px', marginBottom: '12px' };
const featureTitle = { fontSize: '18px', marginBottom: '8px' };
const featureDesc = { color: '#7f8c8d', fontSize: '13px', lineHeight: '1.5' };

const aboutSection = { padding: '60px 4%', background: '#fff', borderTop: '1px solid #eee', boxSizing: 'border-box', width: '100%' };
const aboutGrid = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px', maxWidth: '1100px', margin: '0 auto', boxSizing: 'border-box' };
const aboutTextSide = { textAlign: 'left', boxSizing: 'border-box' }; 
const aboutTitle = { fontSize: '24px', color: '#2c3e50', marginBottom: '15px' };
const aboutText = { color: '#7f8c8d', lineHeight: '1.7', fontSize: '14px' };
const founderBox = { marginTop: '20px', padding: '12px', background: '#f8f9fa', borderRadius: '10px', borderLeft: '4px solid #3498db' };
const contactSide = { background: '#f8f9fa', padding: '25px', borderRadius: '15px', textAlign: 'left', boxSizing: 'border-box' };
const contactInfo = { fontSize: '13px', color: '#444', marginBottom: '10px', wordBreak: 'break-word' };

const footerStyle = { background: '#1a252f', color: '#fff', textAlign: 'center', padding: '30px 4%', boxSizing: 'border-box', width: '100%', fontSize: '13px' };

const cookieBannerStyle = { 
    position: 'fixed', 
    bottom: '15px', 
    left: '15px', 
    right: '15px', 
    background: '#2c3e50', 
    color: '#fff', 
    padding: '15px', 
    borderRadius: '12px', 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    zIndex: 10000, 
    boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
    flexWrap: 'wrap',
    gap: '10px',
    boxSizing: 'border-box'
};

const cookieBtnStyle = { 
    background: '#2ecc71', 
    color: '#fff', 
    border: 'none', 
    padding: '8px 16px', 
    borderRadius: '6px', 
    cursor: 'pointer', 
    fontWeight: 'bold',
    fontSize: '13px'
};